export default __webpack_public_path__ + "static/media/uk.bcbfa15b.svg";